// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";

// import styles bundle
import "swiper/css/bundle";

class CarouselSwiper {
  constructor(container) {
    this.container = container;
    this.navigation = {
      mobile: {
        nextEl: ".card-carousel__footer-navigation .video-next",
        prevEl: ".card-carousel__footer-navigation .video-prev",
      },
      desktop: {
        nextEl: ".card-carousel__header-navigation .video-next",
        prevEl: ".card-carousel__header-navigation .video-prev",
      },
    };
  }

  addListeners(instance) {
    // on Load
    window.addEventListener("load", function () {
      instance.swiperMode();
    });

    // on Resize
    window.addEventListener("resize", function () {
      instance.swiperMode();
    });
  }

  setHidden() {
    for (var x = 0; x < this.swiper.slides.length; x++) {
      if (
        x == this.swiper.activeIndex ||
        x == this.swiper.activeIndex - 1 ||
        x == this.swiper.activeIndex + 1
      ) {
        var remove = this.swiper.slides[x];
        if (remove) remove.classList.remove("card-carousel-hidden");
      } else {
        var add = this.swiper.slides[x];
        if (add) add.classList.add("card-carousel-hidden");
      }
    }
  }

  swiperMode() {
    var self = this;
    if (typeof this.swiper?.destroy === "function")
      this.swiper.destroy(false, true); // clean styles only

    // Enable (for mobile)
    if (window.squiz.breakpoints.sm.matches) {
      let altConfig = {};
      if (document.querySelector(".information-hub")) {
        altConfig = {};
      } else {
        altConfig = {
          a11y: true,
          init: false,
          effect: "cards",
          cardsEffect: {
            perSlideRotate: 3,
            perSlideOffset: 0,
            slideShadows: false,
          },
        };
      }

      let swiperConfig = {
        ...altConfig,
        ...{
          // Optional parameters
          loop: false,
          grabCursor: true,
          direction: "horizontal",
          pagination: {
            el: ".card-carousel__footer-pagination",
            type: "fraction",
          },
          navigation: this.navigation.mobile,
        },
      };

      // home page swiper (cards)
      this.swiper = new Swiper(this.container, swiperConfig);

      if (altConfig?.effect === "cards") {
        this.swiper.on("afterInit", function () {
          self.setHidden();
        });

        this.swiper.on("slideChange", function () {
          self.setHidden();
        });
      }
      this.swiper.init();
    }

    // Enable for desktop & tablet
    else {
      // If we're on the information hub, set the slides per view to 1, else 3.
      const slidesPerView = document.querySelector(".information-hub") ? 1 : 3;

      this.swiper = new Swiper(this.container, {
        // Optional parameters
        a11y: true,
        loop: false,
        grabCursor: true,
        slidesPerView: slidesPerView,
        spaceBetween: 40,
        slidesPerGroup: slidesPerView,
        init: false,
        scrollbar: {
          el: ".swiper-scrollbar",
          draggable: true,
        },
        navigation: this.navigation.desktop,
      });
      this.swiper.init();
    }
  }
}

// check and init swiper
var container = ".card-carousel__container .swiper-container";
if (document.querySelector(container)) {
  const CarouselSwipe = new CarouselSwiper(container);
  CarouselSwipe.addListeners(CarouselSwipe);
}
